import "./style.css";
import Header from "../../../componente/header";
import { useState, useEffect } from "react";
import api from "../../../services/api";

function Manutencao() {
  const { DateTime } = require("luxon");  

    const dt = new Date();
    const date1 =
      dt.getFullYear() +
      "-" +
      (dt.getMonth() + 1).toString().padStart(2, "0") +
      "-" +
      "01";

      const date2 =
      dt.getFullYear() +
      "-" +
      (dt.getMonth() + 1).toString().padStart(2, "0") +
      "-" +
      dt.getDate().toString().padStart(2, "0");

      const date11 =
      dt.getFullYear() +
      "-" +
      (dt.getMonth() + 1).toString().padStart(2, "0") +
      "-" +
      "01";

      const date22 =
      dt.getFullYear() +
      "-" +
      (dt.getMonth() + 1).toString().padStart(2, "0") +
      "-" +
      dt.getDate().toString().padStart(2, "0");

  const [titulo, settitulo] = useState(true);

  const [tipo, settipo] = useState("L");
  const [tipo2, settipo2] = useState("L");

  const [dt1, setdt1] = useState(date1);
  const [dt2, setdt2] = useState(date2);

  const [dt11, setdt11] = useState(date11);
  const [dt22, setdt22] = useState(date22);

  const [abusca, setabusca] = useState("");
  const [abusca2, setabusca2] = useState("");

  const [listatitulo, setlistatitulo] = useState([]);
  const [listadespesa, setlistadespesa] = useState([]);

  useEffect(() => {
    function ListarTitulo() {
      api
        .get("v1/operacoes/manutencaotitulo", {
          params: {
            busca: abusca,
            tipo,
            dt1,
            dt2,
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
          },
        })
        .then(function (response) {
          setlistatitulo(response.data);
        })
        .catch(function (err) {
          console.log("ops! ocorreu um erro: " + err);
        });
    }
    ListarTitulo();
  }, [abusca, dt1, dt2, tipo]);

  useEffect(() => {
    function ListarDespesa() {
      api
        .get("v1/operacoes/manutencaodespesa", {
          params: {
            busca: abusca2,
            tipo: tipo2,
            dt1: dt11,
            dt2: dt22
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
          },
        })
        .then(function (response) {
          setlistadespesa(response.data);
        })
        .catch(function (err) {
          console.log("ops! ocorreu um erro: " + err);
        });
    }
    ListarDespesa();
  }, [abusca2, dt11, dt22, tipo2]);

  function FormataData(props){
    return props ? DateTime.fromISO(props).plus({hours: 3}).toFormat('dd/MM/yyyy') : null;
  }

  function FormataDataHora(props){
    return props ? DateTime.fromISO(props).plus({hours: 3}).toFormat('dd/MM/yyyy HH:mm:ss') : null;
  }

  return (
    <>
      <Header />

      <div className="row">
        <div className="ms-4">
          {titulo ? (
            <h1>Manutenção de Título</h1>
          ) : (
            <h1>Manutenção de Despesa</h1>
          )}
        </div>
        <p className="ms-4">
          Rotina que listam todos os títulos e despesas cadastradas na empresa.
        </p>
        <hr />
      </div>

      {titulo ? (
        <div className="row ps-2 pe-2">
          <div className="col-sm-2 p-2">
            <button
              className="btn btn-primary ms-4"
              onClick={(e) => settitulo(true)}
            >
              Títulos
            </button>
            <button
              className="btn btn-danger ms-4"
              onClick={(e) => settitulo(false)}
            >
              Despesas
            </button>
          </div>

          <div className="col-sm-5">
            <label className="form-label form-check-label" htmlFor="busca">
              Busque aqui
            </label>
            <input
              type="text"
              placeholder="Buscar por: Código ou caixa/banco"
              name="busca"
              id="busca"
              className="form-control me-3"
              value={abusca}
              onChange={(e) => setabusca(e.target.value)}
            />
          </div>

          <div className="col-sm-1">
            <label htmlFor="tipo" className="form-label">
              Filtrar por
            </label>
            <br />
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="tipo"
                value="L"
                onChange={(e) => settipo(e.target.value)}
                checked={tipo === "L"}
              />
              <label className="form-check-label">Lançamento</label>
            </div>

            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="tipo"
                value="V"
                onChange={(e) => settipo(e.target.value)}
                checked={tipo === "V"}
              />
              <label className="form-check-label">Vencimento</label>
            </div>

            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="tipo"
                value="B"
                onChange={(e) => settipo(e.target.value)}
                checked={tipo === "B"}
              />
              <label className="form-check-label">Baixa</label>
            </div>
          </div>

          <div className="col-sm-2">
            <label htmlFor="periodo" className="form-label">
              Dt. Início
            </label>
            <br />
            <input
              type="date"
              id="periodo"
              className="form-control"
              placeholder="Data Inicio"
              value={dt1}
              onChange={(e) => setdt1(e.target.value)}
            />
          </div>

          <div className="col-sm-2">
            <label htmlFor="periodo" className="form-label">
              Dt. Fim
            </label>
            <br />
            <input
              type="date"
              id="periodo2"
              className="form-control"
              placeholder="dtnascimento"
              value={dt2}
              onChange={(e) => setdt2(e.target.value)}
            />
          </div>
        </div>
      ) : (
        <div className="row ps-2 pe-2">
          <div className="col-sm-2 p-2">
            <button
              className="btn btn-primary ms-4"
              onClick={(e) => settitulo(true)}
            >
              Títulos
            </button>
            <button
              className="btn btn-danger ms-4"
              onClick={(e) => settitulo(false)}
            >
              Despesas
            </button>
          </div>

          <div className="col-sm-5">
            <label className="form-check-label" htmlFor="busca">
              Busque aqui
            </label>
            <input
              type="text"
              placeholder="Buscar por: Código ou caixa/banco"
              name="busca"
              id="busca"
              className="form-control me-3"
              value={abusca2}
              onChange={(e) => setabusca2(e.target.value)}
            />
          </div>

          <div className="col-sm-1">
            <label htmlFor="tipo" className="form-label">
              Filtrar por
            </label>
            <br />
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="tipo"
                value="L"
                onChange={(e) => settipo2(e.target.value)}
                checked={tipo2 === "L"}
              />
              <label className="form-check-label">Lançamento</label>
            </div>

            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="tipo"
                value="V"
                onChange={(e) => settipo2(e.target.value)}
                checked={tipo2 === "V"}
              />
              <label className="form-check-label">Vencimento</label>
            </div>

            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="tipo"
                value="B"
                onChange={(e) => settipo2(e.target.value)}
                checked={tipo2 === "B"}
              />
              <label className="form-check-label">Baixa</label>
            </div>
          </div>

          <div className="col-sm-2">
            <label htmlFor="periodo" className="form-label">
              Dt. Início
            </label>
            <br />
            <input
              type="date"
              id="periodo"
              className="form-control"
              placeholder="Data Inicio"
              value={dt11}
              onChange={(e) => setdt11(e.target.value)}
            />
          </div>

          <div className="col-sm-2">
            <label htmlFor="periodo" className="form-label">
              Dt. Fim
            </label>
            <br />
            <input
              type="date"
              id="periodo2"
              className="form-control"
              placeholder="dtnascimento"
              value={dt22}
              onChange={(e) => setdt22(e.target.value)}
            />
          </div>
        </div>
      )}

      <div className="row mt-3">
        <hr />
      </div>

      <div className="row">
        {titulo ? (
          <div className="m-2">
            <table className="table table-hover fonte">
              <thead>
                <tr>
                  <th className="codigo">Código</th>
                  <th className="parcela">Parcela</th>
                  <th className="lancamento">Lançamento</th>
                  <th className="vencimento">Vencimento</th>
                  <th className="baixa">Baixa</th>
                  <th className="cliente">Cliente</th>
                  <th className="valor">Valor</th>
                  <th className="hitorico">Histórico</th>
                  <th className="banco">Banco</th>
                  <th className="moeda">Moeda</th>
                  <th className="acao">Ações</th>
                </tr>
              </thead>
              <tbody>
                {listatitulo.map(function (item) {
                  return (
                    <tr key={item.codcontasreceber}>
                      <th>{item.codcontasreceber}</th>
                      <th>{item.parcela}</th>
                      <th>{FormataDataHora(item.dtlancamento)}</th>
                      <th>{FormataData(item.dtvencimento)}</th>
                      <th>{FormataDataHora(item.dtbaixa)}</th>
                      <th>{item.nome}</th>
                      <th>{item.vlliquido}</th>
                      <th>{item.historico}</th>
                      <th>{item.banco}</th>
                      <th>{item.moeda}</th>
                      <th>
                        <div className="d-flex justify-content-center">                          
                          <button className="btn fa-solid fa-trash"></button>
                        </div>
                      </th>
                    </tr>
                  );
                })}
              </tbody>
              <tfoot>
                <tr>
                  <th colSpan={5}>
                    Quantidade de Registros: {listatitulo.length}
                  </th>
                </tr>
              </tfoot>
            </table>
          </div>
        ) : (
          <div className="m-2">
            <table className="table table-hover fonte">
              <thead>
                <tr>
                  <th className="codigo">Código</th>
                  <th className="parcela">Parcela</th>
                  <th className="lancamento">Lançamento</th>
                  <th className="vencimento">Vencimento</th>
                  <th className="baixa">Baixa</th>
                  <th className="cliente">Nome</th>
                  <th className="valor">Valor</th>
                  <th className="hitorico">Histórico</th>
                  <th className="banco">Banco</th>
                  <th className="moeda">Moeda</th>
                  <th className="acao">Ações</th>
                </tr>
              </thead>
              <tbody>
                {listadespesa.map(function (item) {
                  return (
                    <tr key={item.codcontaspagar}>
                      <th>{item.codcontaspagar}</th>
                      <th>{item.parcela}</th>                      
                      <th>{FormataDataHora(item.dtlancamento)}</th>
                      <th>{FormataData(item.dtvencimento)}</th>
                      <th>{FormataDataHora(item.dtbaixa)}</th>
                      <th>{item.nome}</th>
                      <th>{item.vlliquido}</th>
                      <th>{item.historico}</th>
                      <th>{item.banco}</th>
                      <th>{item.moeda}</th>
                      <th>
                        <div className="d-flex justify-content-center">                          
                          <button className="btn fa-solid fa-trash"></button>
                        </div>
                      </th>
                    </tr>
                  );
                })}
              </tbody>
              <tfoot>
                <tr>
                  <th colSpan={5}>
                    Quantidade de Registros: {listatitulo.length}
                  </th>
                </tr>
              </tfoot>
            </table>
          </div>
        )}
      </div>
    </>
  );
}

export default Manutencao;
